import React, {Component} from 'react'
import PropTypes from 'prop-types'
import {withStyles} from '@material-ui/core'

import {FormElement, SubmitButton} from '../../../components/components'
import TabContainer from '../TabContainer'
import FormElementType from '../../../components/FormElement/FormElementType'
import {metaActions} from '../../../core/actions'

const styles = {
    submitButton: {
        padding: '0.5em 15em 0.5em 15em',
        marginTop: '5em',
        alignSelf: 'center'
    }
}


class BasicInfo extends Component {
    state = {
        isDisabled: false
    }

    componentDidMount () {
        const {projectDetails} = this.props

        if (this.props.projectDetails) {
            Object.keys(this.formInputFields).forEach(key => {
                if (typeof this.formInputFields[key].state.value === 'string') {
                    this.formInputFields[key].setValue(`${projectDetails[key]}`)
                } else if (this.formInputFields[key].state.value instanceof Array) {
                    this.formInputFields[key].setValue(projectDetails[key].map(meta => `${meta.id}`))
                }
            })
        }
    }

    formFields = () => {
        const metas = metaActions.util.formatToMetaOptions(this.props.metas)
        return [
            {label: 'Project Name', name: 'name', minLength: 3, maxLength: 50, type: 'text', required: true},
            {label: 'Authors', name: 'authors', minLength: 3, maxLength: 50, type: 'text', required: true},
            {label: 'Project Description', name: 'description', minLength: 10, maxLength: 500, type: 'text', required: true, multiline: true},
            {label: 'Package Name', name: 'packageName', minLength: 6, maxLength: 25, type: 'text', required: true},
            {label: 'Price', name: 'price', minLength: 0, maxLength: 25, type: 'number'},
            {label: 'Project Categories', name: 'categories', elementType: FormElementType.Select, defaultOption: {None: ''}, required: true, options: metas.categories, multiple: true},
            {label: 'Project User Interface', name: 'interfaces', elementType: FormElementType.Select, defaultOption: {None: ''}, required: true, options: metas.interfaces, multiple: true},
            {label: 'Project OS Support', name: 'platforms', elementType: FormElementType.Select, defaultOption: {None: ''}, required: true, options: metas.platforms, multiple: true},
            {label: 'Project Coded Languages', name: 'languages', elementType: FormElementType.Select, defaultOption: {None: ''}, required: true, options: metas.languages, multiple: true},
            {label: 'Project\'s Framework Dependencies', name: 'frameworks', elementType: FormElementType.Select, defaultOption: {None: ''}, required: true, options: metas.frameworks, multiple: true},
            {label: 'Project Visibility', name: 'listed', elementType: FormElementType.Radio, options: {1: 'Public', 0: 'Unlisted'}}
        ]
    }

    formInputFields = {}

    onValidationChangeDetected = () => {
        const isDisabled = Object.keys(this.formInputFields).find(key => (!this.formInputFields[key].state.isValid)) !== undefined
        this.setState({isDisabled})
    }

    onSubmitUpdate = () => {
        let formData = new FormData()
        Object.keys(this.formInputFields).forEach(key => {
            if (this.formInputFields[key].props.elementType === FormElementType.Select && this.formInputFields[key].props.multiple) {
                this.formInputFields[key].state.value.forEach((item, index) => {
                    formData.append(`${key}[${index}]`, item)
                })
            } else formData.append(key, this.formInputFields[key].state.value)
        })
        this.props.editProjectDetails(this.props.projectDetails.id, formData)
    }

    render () {
        const {classes: styles, active, metas, isUpdatingProject} = this.props

        return (
            <TabContainer active={active} title={'Update Project'}>
                {this.formFields(metas).map((properties, index) => (
                    <FormElement key={index} {...properties} innerRef={ref => (this.formInputFields[properties.name] = ref || this.formInputFields[properties.name])} onValidationChangeDetected={this.onValidationChangeDetected} />
                ))}

                <SubmitButton className={styles.submitButton} isDisabled={this.state.isDisabled} isProcessing={isUpdatingProject} onClick={this.onSubmitUpdate} loadingText={'Updating..'}>Update</SubmitButton>
            </TabContainer>
        )
    }
}

BasicInfo.propTypes = {
    classes: PropTypes.object,
    active: PropTypes.bool,
    metas: PropTypes.array,
    isUpdatingProject: PropTypes.bool,
    projectDetails: PropTypes.object,
    editProjectDetails: PropTypes.func
}

export default withStyles(styles)(BasicInfo);
